import { render, staticRenderFns } from "./dates.vue?vue&type=template&id=66bc3e97"
import script from "./dates.vue?vue&type=script&lang=js"
export * from "./dates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports